import React, { FC } from 'react';

import { LoadScript } from '@react-google-maps/api';

const GoogleMapWrapper: FC<{
    children: React.ReactNode;
}> = ({ children }) => {
  return (
    <LoadScript
      libraries={['places']}
      googleMapsApiKey="AIzaSyDD2xolNUFyUhWnPDXJo1hi0pjhFpw85vY">
      <div>{children}</div>
    </LoadScript>
  );
};

export default GoogleMapWrapper;
